<template>
  <a-drawer
    :title="detail ? '编辑账号' : '新建账号'"
    width="600"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="onClose"
  >
    <!-- form -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 账号ID -->
      <a-form-item
        label="账号ID"
        name="channel_id"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input v-model:value="formState.channel_id" placeholder="请输入" />
      </a-form-item>
      <!-- 账号名称 -->
      <a-form-item
        label="账号名称"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          v-model:value="formState.name"
          placeholder="请输入"
        />
      </a-form-item>
      <!-- 媒体 -->
      <a-form-item
        label="媒体"
        name="type"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-select
          v-model:value="formState.type"
          placeholder="请选择"
        >
          <a-select-option v-for="item in MediaTypes" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- 账号语种 -->
      <a-form-item
        label="账号语种"
        name="lang_id"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-select
          v-model:value="formState.lang_id"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in languages"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 人群分类 -->
      <a-form-item
        label="人群分类"
        name="people_type"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-select
          v-model:value="formState.people_type"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in AudienceTypes"
            :key="`${item.value}-${item.text}`"
            :value="item.value"
          >
            {{ item.text }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <!-- 运营负责人 -->
      <a-form-item
        label="运营负责人"
        name="admin_id"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-select
          v-model:value="formState.admin_id"
          placeholder="请选择"
        >
          <a-select-option
            v-for="item in adminList"
            :key="`${item.id}-${item.name}`"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { reactive, ref, nextTick } from 'vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { MediaTypes, AudienceTypes } from '@/utils/constantList'
import { message } from 'ant-design-vue'
// 引入 API
import { accountSave, langSearchList, adminAll } from '@/api/admin'

// emit
const emit = defineEmits(['success'])
// form
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 语种列表
let languages= ref([])
// 运营负责人列表
let adminList= ref([])
// 修改对象
let detail = ref(null)

// 表单参数
const formState = ref({
  // 账号ID
  channel_id: undefined,
  // 账户名称
  name: undefined,
  // 媒体
  type: undefined,
  // 账号语种
  lang_id: undefined,
  // 人群分类
  people_type: undefined,
  // 运营负责人
  admin_id: undefined
})

// 显示弹窗
function showDrawer(record) {
  visible.value = true
  detail.value = record
  
  // 如果有记录数据，则为编辑模式，填充表单
  if (record && record.id) {
    nextTick(() => {
      formState.value = {
        channel_id: record.channel_id,
        name: record.name,
        type: record.type,
        lang_id: record.lang_id,
        people_type: record.people_type,
        admin_id: record.admin_id
      }
    })
  } else {
    // 新建模式，重置表单
    nextTick(() => {
      formState.value = {
        channel_id: undefined,
        name: undefined,
        type: undefined,
        lang_id: undefined,
        people_type: undefined,
        admin_id: undefined
      }
    })
  }
  // 获取选择项
  getSelectList()
}

// 获取选择项
function getSelectList() {
  langSearchList().then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      languages.value = data
    }
  })
  adminAll().then(res => {
    const { code, msg, data } = res
    if (code === 0) {
      adminList.value = data
    }
  })
}

// 关闭弹窗
function onClose() {
  visible.value = false
  // 重置表单
  RefForm.value?.resetFields()
  formState.value = {
    channel_id: undefined,
    name: undefined,
    type: undefined,
    lang_id: undefined,
    people_type: undefined,
    admin_id: undefined
  }
  detail.value = null
}

// 提交
function touchSubmit() {
  RefForm.value.validate().then((res) => {
    // 上传数据
    const params = {
      id: detail.value && detail.value.id,
      ...res,
    }
    isLoading.value = true
    // TODO: 替换为实际的API调用
    accountSave(params).then((res) => {
      isLoading.value = false
      if (res.code === 0) {
        message.success('保存成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message)
      }
    }).catch(() => {
      isLoading.value = false
      message.error('保存失败')
    })
  }).catch((err) => {
    console.log(err)
  })
}

// 暴露方法给父组件
defineExpose({
  showDrawer
})
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>
